import { Node_Type } from 'ricos-types';
import { CODE_BLOCK_TYPE } from 'wix-rich-content-common';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import CodeBlockIcon from './icons/toolbars-v3/CodeBlockIcon.js';
import 'react';

const getTextButtons = () => {
  return [
    {
      id: Node_Type.CODE_BLOCK,
      type: "toggle",
      presentation: {
        dataHook: "TextCodeBlockButton",
        tooltip: "TextCodeBlockButton_Tooltip",
        tooltipShortcut: {
          MacOS: " (\u2318\u21E7C)",
          Windows: " (Ctrl+\u21E7+C)"
        },
        icon: CodeBlockIcon
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_CODE_BLOCK,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      command: ({ editorCommands }) => () => {
        editorCommands.setBlockType(CODE_BLOCK_TYPE);
        return true;
      }
    }
  ];
};

export { getTextButtons };
//# sourceMappingURL=getTextButtons.js.map
